// extracted by mini-css-extract-plugin
export default {"lineChartSvg":"LineChart_lineChartSvg__-7Ohj"};